import React, { useEffect, useState } from 'react';
import { Category, LearningAsset, Tag } from '../../../../../model/response';
import { Pagination, TablePaginationConfig } from 'antd';
import LearningAssetEditView from '../LearningAssetEditView';
import { LoadingOutlined } from '@ant-design/icons';
import { findAllTags } from '../../../../../service/tagService';
import { findAllCategories } from '../../../../../service/categoryService';

interface LearningAssetPageProps {
  learningAssetFetching: boolean;
  learningAssets: LearningAsset[];
  pagingParams: TablePaginationConfig;
  setPagingParams: (pagingParams: TablePaginationConfig) => void;
}

function LearningAssetPage({
  learningAssetFetching,
  learningAssets,
  pagingParams,
  setPagingParams,
}: LearningAssetPageProps) {
  const [tags, setTags] = useState<Tag[]>([]);
  const [tagFetching, setTagFetching] = useState(false);
  const [categories, setCategories] = useState<Category[]>([]);
  const [categoryFetching, setCategoryFetching] = useState(false);

  useEffect(() => {
    fetchTags();
    fetchCategories();
  }, []);

  function fetchTags() {
    if (tagFetching) return;
    setTagFetching(true);
    findAllTags()
      .then((tags) => setTags(tags))
      .catch((e) => console.error(e))
      .finally(() => setTagFetching(false));
  }

  function fetchCategories() {
    if (categoryFetching) return;
    setCategoryFetching(true);
    findAllCategories()
      .then((categories) => setCategories(categories))
      .catch((e) => console.error(e))
      .finally(() => setCategoryFetching(false));
  }

  const handleChangePage = (page: number, pageSize: number) => {
    setPagingParams({
      ...pagingParams,
      current: page,
      pageSize,
    });
  };

  const handleSizeChange = (current: number, pageSize: number) => {
    setPagingParams({
      ...pagingParams,
      current,
      pageSize,
    });
  };

  if (learningAssetFetching) {
    return (
      <div className={'px-4 py-8 flex justify-center items-center w-full'}>
        <LoadingOutlined />
      </div>
    );
  }

  if (!learningAssets.length) {
    return <div className={'px-4 py-8 h-8 flex justify-center items-center text-sm w-full'}>Danh sách trống</div>;
  }

  return (
    <div className={'flex flex-col gap-y-4 px-4 py-8'}>
      <div>
        <Pagination
          {...pagingParams}
          onChange={handleChangePage}
          showSizeChanger={true}
          onShowSizeChange={handleSizeChange}
        />
      </div>
      <div className={'flex flex-col gap-y-4 h-[calc(100vh-210px)] overflow-y-auto'}>
        {learningAssets.map((learningAsset) => (
          <LearningAssetEditView
            learningAsset={learningAsset}
            key={learningAsset.id}
            tags={tags}
            fetchTags={fetchTags}
            categories={categories}
            categoryFetching={categoryFetching}
            fetchCategories={fetchCategories}
            tagFetching={tagFetching}
          />
        ))}
      </div>
    </div>
  );
}

export default LearningAssetPage;
